import React, { useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { Button, FormControl } from "react-bootstrap";
import { useEffect } from "react";
const API_URL = process.env.REACT_APP_API_URL;



function CometAssay() {

    const { sample_id } = useParams();

    const [successMsg, setSuccessMsg] = useState("");
    const [errorMsg, setErrorMsg] = useState("");




    const [values, setValues] = useState({
        sample_id: "",
        sample_code:"",
        noMigration: "",
        ssbMigration: "",
        dsbMigration: "",
        bothDamageMigration: "",
        total: "",
        undamaged: "",
        bothDamaged: "",
        ssbDfi: "",
        dsbDfi: "",
        ssbDsbDfi: "",
        comet_id: ""
    });

    const fieldMap = {
        "No DNA migration": "noMigration",
        "SSB migration": "ssbMigration",
        "DSB migration": "dsbMigration",
        "Both damage migration": "bothDamageMigration"
    };

    const inputStyle = {
        width: "120px",
        padding: "6px 12px",
        height: "35px",
        border: "2px solid #001A43",
        borderRadius: "6px",
        margin: "6px 0"
    };

    const labelStyle = {
        backgroundColor: "#DFF5F1",
        width: "200px",
        padding: "6px 12px",
        margin: "6px 0",
        borderRadius: "6px",
        border: "1px solid #4DB6AC",
        textAlign: "center"
    };

    const buttonStyle = {
        backgroundColor: "#FFF2CC",
        border: "1px solid #e0c97f",
        color: "black",
        width: "220px",
        margin: "10px 0"
    };

    const handleChange = (field, val) => {
        const updated = { ...values, [field]: val };

        const noMig = Number(updated.noMigration) || 0;
        const ssb = Number(updated.ssbMigration) || 0;
        const dsb = Number(updated.dsbMigration) || 0;
        const both = Number(updated.bothDamageMigration) || 0;

        // Total
        const total = noMig + ssb + dsb + both;
        updated.total = total;

        // Undamaged & both damaged
        updated.undamaged = noMig;
        updated.bothDamaged = both;

        // DFI calculations (EXACT as per document)
        updated.ssbDfi = total > 0 ? ((ssb / total) * 100).toFixed(2) : "";
        updated.dsbDfi = total > 0 ? ((dsb / total) * 100).toFixed(2) : "";
        updated.ssbDsbDfi = total > 0 ? ((both / total) * 100).toFixed(2) : "";

        setValues(updated);
    };




    useEffect(() => {
        const fetchData = async () => {
            try {
                const res = await axios.get(
                    `${API_URL}/dfi-data-COMET-assay/${sample_id}`
                );

                if (res.data.status && res.data.PiwilMrnaModel) {
                    const d = res.data.PiwilMrnaModel;

                    setValues({
                        sample_id: d.sample_id,
                        comet_id: d.comet_id,
                        noMigration: d.dna_migration ?? "",
                        ssbMigration: d.ssb_migration ?? "",
                        dsbMigration: d.dsb_migration ?? "",
                        bothDamageMigration: d.both_damage_migration ?? "",
                        total: d.total ?? "",
                        undamaged: d.undamaged ?? "",
                        bothDamaged: d.both_damage ?? "",
                        ssbDfi: d.ssb_index ?? "",
                        dsbDfi: d.dsb_index ?? "",
                        ssbDsbDfi: d.both_index ?? "",
                        remark: d.remark ?? ""
                    });
                }
            } catch (err) {
                console.error("Fetch error", err);
            }
        };

        fetchData();
    }, [sample_id]);



    const handleSave = async () => {
        try {
            const token = localStorage.getItem("token");

            const res = await axios.post(
                `${API_URL}/update-comet-assay/${values.comet_id}`,
                {
                    dna_migration: values.noMigration,
                    ssb_migration: values.ssbMigration,
                    dsb_migration: values.dsbMigration,
                    both_damage_migration: values.bothDamageMigration,
                    total: values.total,
                    undamaged: values.undamaged,
                    both_damage: values.bothDamaged,
                    ssb_index: values.ssbDfi,
                    dsb_index: values.dsbDfi,
                    both_index: values.ssbDsbDfi,
                    remark: values.remark
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }
            );

            // alert(res.data.message || "Saved successfully");
            // setErrorMsg("");
             setSuccessMsg(
                res.data.message || `DFI data - COMET assay data saved successfully`
            ); setErrorMsg("");

            setTimeout(() => setSuccessMsg(""), 1000);

        } catch (error) {
            console.error("Save error:", error);

            if (error.response?.status === 401) {
                setErrorMsg("Unauthorized. Please login again.");
            } else {
                setErrorMsg("Update failed");
            }
        }
    };










    return (
        <div style={{ padding: "30px" }}>
            <h6 style={{ textAlign: "left" }}>DFI data - COMET assay </h6>

             {successMsg && (
                <div className="alert alert-success mt-2">
                    {successMsg}
                </div>
            )}

            {errorMsg && (
                <div className="alert alert-danger mt-2">
                    {errorMsg}
                </div>
            )}

            <div
                style={{
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr 1fr",
                    gap: "40px",
                    marginTop: "30px"
                }}
            >
                <div>
                    {[
                        "No DNA migration",
                        "SSB migration",
                        "DSB migration",
                        "Both damage migration",
                        "Total"
                    ].map((label, idx) => (
                        <div key={idx} style={{ display: "flex", alignItems: "center", gap: "20px" }}>
                            <div style={labelStyle}>{label}</div>
                            {label === "Total" ? (
                                <FormControl type="number"
                                    style={{ ...inputStyle, backgroundColor: "#E8F0FF" }}
                                    readOnly
                                    value={values.total}
                                />
                            ) : (

                                <FormControl type="number"
                                    style={inputStyle}
                                    value={values[fieldMap[label]] ?? ""}
                                    onChange={(e) => handleChange(fieldMap[label], e.target.value)}
                                />
                            )}
                        </div>
                    ))}
                </div>

                <div>
                    {[
                        { label: "Undamaged", value: values.undamaged },
                        { label: "Both Damaged", value: values.bothDamaged }
                    ].map(({ label, value }, idx) => (
                        <div key={idx} style={{ display: "flex", alignItems: "center", gap: "20px" }}>
                            <div style={labelStyle}>{label}</div>
                            <FormControl type="number"
                                style={{ ...inputStyle, backgroundColor: "#E8F0FF" }}
                                readOnly
                                value={value}
                            />
                        </div>
                    ))}


                </div>

                <div>
                    {[
                        { label: "SSB DNA fragmentation index DFI (%)", value: values.ssbDfi },
                        { label: "DSB DNA fragmentation index DFI (%)", value: values.dsbDfi },
                        { label: "SSB & DSB DNA fragmentation index DFI (%)", value: values.ssbDsbDfi }
                    ].map(({ label, value }, idx) => (
                        <div key={idx} style={{ display: "flex", alignItems: "center", gap: "20px", marginBottom: 15 }}>
                            <div style={labelStyle}>{label}</div>
                            <FormControl type="number"
                                style={{ ...inputStyle, backgroundColor: "#E8F0FF" }}
                                readOnly
                                value={value}
                            />
                        </div>
                    ))}
                </div>




            </div>


            <div className="mb-3">

                <FormControl
                    as="textarea"
                    rows={2}
                    placeholder="Enter remarks here" style={{ width: "1000px", marginTop: "30px" }}
                    value={values.remark ?? ""}
                    onChange={(e) =>
                        setValues({ ...values, remark: e.target.value })
                    }
                />

            </div>
            <div className="d-flex justify-content-center mt-4">
                <Button
                    type="submit"
                    variant="primary"
                    className="px-4 mb-4"
                    onClick={handleSave}

                >
                    Save
                </Button>
            </div>
        </div>
    );
}

export default CometAssay;